import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {IconoirProhibition} from '@ey-xd/motif-icon';
import OutputText from '@ey/canvascoreservices/OutputText';

import Button from '../../../CoreWrappers/Button';

const ButtonDrydock = () => {
	const renderTitle = (text) => (
		<OutputText h2 className="full">
			{text}
		</OutputText>
	);

	const renderGroup = (title, list, renderItem) => (
		<>
			{renderTitle(title)}
			<div className="items">{list.map(renderItem)}</div>
		</>
	);

	const variants = ['Primary', 'Secondary', 'Primary-alt', 'Ghost', 'Text', 'Text-alt'];
	const renderVariant = (variant = 'Primary') => {
		const props = {
			label: variant,
			variant: variant.toLowerCase()
		};

		return <Button {...props} />;
	};

	const sizes = ['Small', 'Medium', 'Large'];
	const renderSize = (size = 'Small') => {
		const props = {
			label: size,
			size: size.toLowerCase()
		};

		return <Button {...props} />;
	};
	const renderSizeIconOnly = (size = 'Small') => {
		const props = {
			svg: IconoirProhibition,
			size: size.toLowerCase()
		};

		return <Button {...props} />;
	};

	return (
		<StyledButtonDrydock className="full">
			{renderGroup('Variants', variants, renderVariant)}
			<div className="items">
				{renderVariant('Text')}
				{renderVariant('Text-alt')}
			</div>
			{renderGroup('Sizes', sizes, renderSize)}
			{renderGroup('Icon only', sizes, renderSizeIconOnly)}
		</StyledButtonDrydock>
	);
};

ButtonDrydock.propTypes = {};

export default ButtonDrydock;

const StyledButtonDrydock = styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--spacing-large);
	.items {
		display: flex;
		gap: inherit;
	}
`;
